export type LocationScopeFilterT = {
  readonly locationIds?: string[];
  readonly excludedLocationIds?: string[];
  readonly includeUnassigned?: boolean;
};

const normalizeLocationId = (value: string): string => value.trim();

export const normalizeLocationIds = (locationIds?: string[]): string[] => {
  if (!Array.isArray(locationIds) || locationIds.length === 0) {
    return [];
  }

  return [...new Set(locationIds.map(normalizeLocationId).filter(Boolean))];
};

export const createLocationScopeMatcher = (
  scope?: LocationScopeFilterT
): ((assignedLocationIds?: string[]) => boolean) => {
  const scopedLocationIds = normalizeLocationIds(scope?.locationIds);
  const scopedLocationIdSet = new Set(scopedLocationIds);
  const excludedLocationIds = normalizeLocationIds(scope?.excludedLocationIds);
  const excludedLocationIdSet = new Set(excludedLocationIds);
  const includeUnassigned = scope?.includeUnassigned === true;

  if (
    scopedLocationIds.length === 0 &&
    excludedLocationIds.length === 0 &&
    !includeUnassigned
  ) {
    return () => true;
  }

  return (assignedLocationIds?: string[]): boolean => {
    const normalizedAssignedLocationIds =
      normalizeLocationIds(assignedLocationIds);

    if (normalizedAssignedLocationIds.length === 0) {
      return includeUnassigned;
    }

    const allowedAssignedLocationIds = normalizedAssignedLocationIds.filter(
      (locationId) => !excludedLocationIdSet.has(locationId)
    );

    if (allowedAssignedLocationIds.length === 0) {
      return false;
    }

    if (scopedLocationIdSet.size === 0) {
      return true;
    }

    return allowedAssignedLocationIds.some((locationId) =>
      scopedLocationIdSet.has(locationId)
    );
  };
};
